import { gql } from "@apollo/client"
export const getAllMerchantsQuery = gql`
  query getMerchant(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllMerchant(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        merchantName
        description
        mobileNumber
        address
        logoURL
        activatedBy
        activatedDate
        registeredOnDate
        isDeleted
        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const createMerchantMutation = gql`
  mutation createMerchant($data: merchantInput) {
    createOneMerchant(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateMerchantMutation = gql`
  mutation updateMerchant($id: Int!, $data: merchantInput) {
    updateOneMerchant(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`

export const deleteMerchantMutation = gql`
  mutation deleteMerchant($id: Int!) {
    deleteOneMerchant(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`

export const fileUploadQuery = gql`
  query getUploadUrl($type: String!, $fileName: String!) {
    getUploadUrl(type: $type, fileName: $fileName) {
      status

      url

      error {
        message
      }
    }
  }
`
